<template>
    <div class="main-content bg-login-default min-vh-100">
        <!-- Navbar -->
        <base-nav class="navbar-top navbar-horizontal navbar-dark"
                  containerClasses="px-4 container"
                  v-if="!isAndroidApp()"
                  expand>
            <router-link slot="brand" class="navbar-brand" to="/">
                <img :src="$t('logo_yellow')"/>
            </router-link>

            <template v-slot="{closeMenu}">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img :src="$t('logo_green')">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button"
                                    @click="closeMenu"
                                    class="navbar-toggler"
                                    aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navbar items -->
                <ul class="login-navbar-nav navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/user/signin">
                            <i class="ni ni-key-25"></i>
                            <span class="nav-link-inner--text">{{ $t('login') }}</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link nav-link-icon" to="/user/signin">
                            <i class="ni ni-circle-08"></i>
                            <span class="nav-link-inner--text">{{ $t('register') }}</span>
                        </router-link>
                    </li>
                </ul>
            </template>
        </base-nav>
        <!-- Header -->
        <div class="header py-6 py-lg-4">
            <div class="container">
                <div class="header-body text-center mb-7">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-6">
                            <h1 class="text-white">{{ $t('welcome') }}</h1>
                            <p class="text-lead text-white welcome-notice">{{ $t('auth_notice') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5" v-if="!isAndroidApp()">
            <div class="container">
                <div class="row align-items-center justify-content-xl-between">
                    <div class="col-xl-6">
                        <div class="copyright text-center text-xl-left text-muted">
                            &copy; {{ $t('start_year_copy') }}{{year}} <a href="https://www.poliglotiki.ru/" class="font-weight-bold ml-1"
                                               target="_blank">{{ $t('POLIGLOTIKI') }}</a> - {{ $t('footer_slogan') }}
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
                            <li class="nav-item">
                                <router-link to="/entry" class="ml-1 footer-callback">{{ $t('callback') }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'
  import {isAndroid} from "../data/AndroidApi";

  export default {
      name: 'auth-layout',
      components: {
          SlideYUpTransition
      },
      data() {
          return {
              year: new Date().getFullYear(),
              showMenu: false,
          }
      },
      methods: {
          isAndroidApp() {
              return isAndroid()
          },
      }
  }
</script>
<style>
</style>
